import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { GO_DOCUMENTATION } from '@/constants/paths';

const ApiDocumentationCallToActionCard = () => {
  const theme = useTheme();

  return (
    <Paper
      component="a"
      href={GO_DOCUMENTATION.createOrder}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Ir a documentación (abre en una nueva pestaña)"
      elevation={3}
      className="flex h-24 w-full flex-col justify-center gap-1 px-4 no-underline"
      sx={{
        backgroundColor: theme.palette.secondary.main,
        transition: 'box-shadow 0.2s ease',
        '&:hover': { boxShadow: theme.shadows[6] },
      }}
    >
      <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 700 }}>
        ¿No ves tu plataforma?
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff', fontWeight: 600 }}>
        Conéctala con nuestra API.
      </Typography>
      <Typography
        variant="caption"
        className="mt-1 flex items-center gap-1"
        sx={{ color: theme.palette.primary.main, fontWeight: 700 }}
      >
        Ir a documentación
        <OpenInNewIcon sx={{ fontSize: 14 }} />
      </Typography>
    </Paper>
  );
};

export default ApiDocumentationCallToActionCard;
